export default __webpack_public_path__ + "static/media/5.af7264d6.png";